import { render, staticRenderFns } from "./ProductDetailOnlif.vue?vue&type=template&id=d5777cb8&scoped=true&"
import script from "./ProductDetailOnlif.vue?vue&type=script&lang=js&"
export * from "./ProductDetailOnlif.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailOnlif.vue?vue&type=style&index=0&id=d5777cb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5777cb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
